/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v1
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ErrorResponse } from '../model';
// @ts-ignore
import type { HTTPValidationError } from '../model';
// @ts-ignore
import type { RequirementAggregator } from '../model';
/**
 * RequirementsApi - axios parameter creator
 */
export const RequirementsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the requirement with the given id. Args:     requirement_id (UUID): The requirement\'s id.  Returns:     requirement: The requirement with the given id.
         * @summary Get Requirement
         * @param {string} requirementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequirementRequirementsRequirementIdGet: async (requirementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requirementId' is not null or undefined
            assertParamExists('getRequirementRequirementsRequirementIdGet', 'requirementId', requirementId)
            const localVarPath = `/requirements/{requirement_id}`
                .replace('{requirement_id}', encodeURIComponent(String(requirementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RequirementsApi - functional programming interface
 */
export const RequirementsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RequirementsApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the requirement with the given id. Args:     requirement_id (UUID): The requirement\'s id.  Returns:     requirement: The requirement with the given id.
         * @summary Get Requirement
         * @param {string} requirementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRequirementRequirementsRequirementIdGet(requirementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RequirementAggregator>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRequirementRequirementsRequirementIdGet(requirementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RequirementsApi.getRequirementRequirementsRequirementIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RequirementsApi - factory interface
 */
export const RequirementsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RequirementsApiFp(configuration)
    return {
        /**
         * Returns the requirement with the given id. Args:     requirement_id (UUID): The requirement\'s id.  Returns:     requirement: The requirement with the given id.
         * @summary Get Requirement
         * @param {RequirementsApiGetRequirementRequirementsRequirementIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequirementRequirementsRequirementIdGet(requestParameters: RequirementsApiGetRequirementRequirementsRequirementIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<RequirementAggregator> {
            return localVarFp.getRequirementRequirementsRequirementIdGet(requestParameters.requirementId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getRequirementRequirementsRequirementIdGet operation in RequirementsApi.
 */
export interface RequirementsApiGetRequirementRequirementsRequirementIdGetRequest {
    readonly requirementId: string
}

/**
 * RequirementsApi - object-oriented interface
 */
export class RequirementsApi extends BaseAPI {
    /**
     * Returns the requirement with the given id. Args:     requirement_id (UUID): The requirement\'s id.  Returns:     requirement: The requirement with the given id.
     * @summary Get Requirement
     * @param {RequirementsApiGetRequirementRequirementsRequirementIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRequirementRequirementsRequirementIdGet(requestParameters: RequirementsApiGetRequirementRequirementsRequirementIdGetRequest, options?: RawAxiosRequestConfig) {
        return RequirementsApiFp(this.configuration).getRequirementRequirementsRequirementIdGet(requestParameters.requirementId, options).then((request) => request(this.axios, this.basePath));
    }
}

